import React, { lazy, Suspense, useContext } from "react";
import useVideoControls from "../../../../hooks/chat/useVideoControls";
import { useAppSelector } from "../../../../store/index.ts";
import { ENUM_ELEMENT_NAME } from "../../../common/enums.js";
import { AudioContextRef, ChatWindowContextRef } from "../../../../pages/CurrentModel.jsx";
import "./broadcaster-window.scss";
import useStreamStatus from "../../../../hooks/site/useStreamStatus.js";
import VideoDraw from "../zoomist/video_canvas/video_draw/VideoDraw.jsx";
import ZoomistContainer from "../zoomist/ZoomistWrapper.jsx";
import UnavailableControl from "../unavailable_modal/UnavailableControl.jsx";
import SupportWebRTC from "../../../mui/SupportWebRTC.jsx";

const ChatControls = lazy(() => import("../controls/chat_controls/ChatControls"));

export default function BroadcasterWindow() {
  const audioRef = useContext(AudioContextRef);
  const chatWindowRef = useContext(ChatWindowContextRef);
  const loadingBroadcaster = useAppSelector((state) => state.chat.loadingBroadcaster);
  const { isStream } = useStreamStatus();

  const { onMouseEnter, onMouseLeave, onTouchClick, onUnMute, onLoadedAudioData } =
    useVideoControls();

  const chatHide = loadingBroadcaster && isStream ? "hide-video-canvas" : "";

  return (
    <div
      className={`chat__window ${chatHide}`}
      name={ENUM_ELEMENT_NAME.streamWindow}
      ref={chatWindowRef}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onTouchEnd={onTouchClick}
      onClick={() => {
        onUnMute();
        onTouchClick();
      }}
    >
      <audio
        ref={audioRef}
        autoPlay
        controls
        style={{ opacity: 0, position: "absolute" }}
        onLoadedData={onLoadedAudioData}
      />

      <VideoDraw />
      <ZoomistContainer />
      <Suspense>
        <UnavailableControl />
      </Suspense>

      <Suspense>
        <SupportWebRTC />
      </Suspense>

      <Suspense>
        <ChatControls onUnMute={onUnMute} />
      </Suspense>
    </div>
  );
}
